import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let AmFrame = class AmFrame extends Vue {
  // @Prop({ default: 'horizontal' }) direction!: string
  // @Prop({ default: 0 }) active!: number
  // @Prop({ default: 'process' }) processStatus!: string
  // @Prop({ default: 'finish' }) finishStatus!: string
  // @Prop({ default: false }) alignCenter!: boolean
  // @Prop({ default: false }) simple!: boolean
  // @Prop({ default: () => [] }) options!: Array<any>
  // @Prop({ default: 1 }) type!: number
  get lineStyle() {
    return `height: ${this.height};width:${this.width};`;
  }
};
AmFrame.componentName = 'AmFrame';
__decorate([Prop({
  default: 'about:blank'
})], AmFrame.prototype, "url", void 0);
__decorate([Prop()], AmFrame.prototype, "mode", void 0);
__decorate([Prop({
  default: '100%'
})], AmFrame.prototype, "width", void 0);
__decorate([Prop({
  default: '100%'
})], AmFrame.prototype, "height", void 0);
__decorate([Prop({
  default: 'no'
})], AmFrame.prototype, "scrolling", void 0);
AmFrame = __decorate([Component({
  name: 'AmFrame'
})], AmFrame);
export default AmFrame;